import { Pipe, PipeTransform } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ShiftIdWithPosition } from '../services/shift-multi-select-helper.service';

@Pipe({
  name: 'isShiftSelected',
  standalone: true,
})
export class IsShiftSelectedPipe implements PipeTransform {
  transform(
    shiftsWithPosition: Observable<ShiftIdWithPosition[]>,
    shiftId: string,
  ): Observable<boolean> {
    return shiftsWithPosition.pipe(
      map((shiftsWithPosition) => {
        return shiftsWithPosition.some((shift) => shift.id === shiftId);
      }),
    );
  }
}
